import React from 'react';

const Topics = () => {
    return (
        <div>
            <h2>This is topics</h2>
        </div>
    );
};

export default Topics;